import React from 'react';
import { uniqueId } from 'lodash'
import { I18n } from 'react-redux-i18n';

import FooterNav from './FooterNav/FooterNav'
import { getA2IAllReportsLink } from '../../helpers/AppHelper'
import CONFIG from '../../config/config'

import zaddMobileLogo from '../../assets/footer/mobile-zadd-logo.svg';
import hrdfLogo from '../../assets/footer/hrdf-logo.svg';
import aiLogo from '../../assets/footer/2026-ai-black.svg';
import xIcon from '../../assets/footer/x-icon.svg';
import igIcon from '../../assets/footer/ig-icon.svg';

import './Footer.scss';

const TERMS_URL = 'https://910ths.sa/%D8%B4%D8%B1%D9%88%D8%B7-%D8%A7%D9%84%D8%A7%D8%B3%D8%AA%D8%AE%D8%AF%D8%A7%D9%85/';
const PRIVACY_URL = 'https://910ths.sa/%D8%B3%D9%8A%D8%A7%D8%B3%D8%A9-%D8%A7%D9%84%D8%AE%D8%B5%D9%88%D8%B5%D9%8A%D8%A9/';

const Footer = () => {
  const navItems = [
    {
      href: CONFIG.a2iLink,
      translationKey: 'footer.navigation.mainPage',
      keyId: uniqueId('footer-nav-'),
    },
    {
      href: '.',
      translationKey: 'footer.navigation.interactiveMap',
      keyId: uniqueId('footer-nav-'),
      isSelected: true,
    },
    {
      href: getA2IAllReportsLink('all'),
      translationKey: 'footer.navigation.reports',
      keyId: uniqueId('footer-nav-'),
    },
  ]

  return <footer className='Footer'>
    <div className='Footer__content'>
      <div className='Footer__content__section Footer__content__section--brand'>
        <div className='logo-container'>
          <img src={zaddMobileLogo} alt='' />
        </div>
      </div>

      <div className='Footer__content__main'>
        <div className='Footer__content__category Footer__content__category--social'>
          <h3 className='Footer__content__category__title'>
            {I18n.t('footer.categories.followUs')}
          </h3>
          <div className='Footer__content__category__icons'>
            <a href='https://x.com/910ths' target='_blank' rel='noopener noreferrer'>
              <img src={xIcon} alt='9/10ths X Profile' />
            </a>
            <a href='https://www.instagram.com/910ths' target='_blank' rel='noopener noreferrer'>
              <img src={igIcon} alt='9/10ths Instagram Profile' />
            </a>
          </div>
        </div>

        <div className='Footer__content__category'>
          <h3 className='Footer__content__category__title'>
            {I18n.t('footer.categories.supportAndHelp')}
          </h3>
          <div className='Footer__content__category__links'>
            <a href={TERMS_URL} target='_blank' rel='noopener noreferrer'>
              {I18n.t('footer.pages.termsAndConditions')}
            </a>
            <a href={PRIVACY_URL} target='_blank' rel='noopener noreferrer'>
              {I18n.t('footer.pages.privacyPolicy')}
            </a>
          </div>
        </div>

        <div className='Footer__content__category'>
          <h3 className='Footer__content__category__title'>
            {I18n.t('footer.categories.businessServices')}
          </h3>
          <FooterNav items={navItems} />
        </div>

        <div className='Footer__content__partners'>
          <div className='Footer__content__partners__logo Footer__content__partners__logo--ai'>
            <img src={aiLogo} alt='2026 AI' />
          </div>
          <div className='Footer__content__partners__logo'>
            <span className='Footer__content__partners__text'>{I18n.t('footer.initiativeBy')}</span>
            <img src={hrdfLogo} alt='' />
          </div>
        </div>
      </div>
    </div>
  </footer>;
}

export default Footer;
